import { Alert, AlertProps, AlertTitle, Link } from "@mui/material";
import * as React from "react";

import {
  AssociationType,
  fileAssociationType,
} from "@/shared/domain/association";

import { useInheritedFiles } from "./inheritedFiles";

interface NoFilesUploadedAlertProps extends AlertProps {
  associationId: string;
}

export const NoFilesUploadedAlert: React.FC<NoFilesUploadedAlertProps> = ({
  associationId,
  ...props
}) => {
  const isDataset =
    fileAssociationType(associationId) === AssociationType.Dataset;
  const isInherited = useInheritedFiles() !== null;

  if (isInherited) {
    return (
      <Alert severity="info" {...props}>
        The device type has no configurations in this folder.
      </Alert>
    );
  }

  return (
    <Alert
      severity="info"
      style={{
        border: "1px dotted #C3CAD9",
      }}
      {...props}
    >
      <AlertTitle>Drag in files to upload</AlertTitle>
      {/* The Roboto CLI uploads files only to datasets. */}
      {isDataset ? (
        <>
          You can drag them in here, or use the{" "}
          <Link
            underline="hover"
            target="_blank"
            href="https://docs.roboto.ai/getting-started/programmatic-access.html#python-sdk-and-cli"
          >
            Roboto CLI
          </Link>
          :
          <br />
          <br />
          <span
            style={{
              fontFamily: "monospace",
              fontSize: "0.8rem",
            }}
          >
            $ roboto datasets upload-files -d {associationId} -p{" "}
            {"<path/to/files>"}
          </span>
        </>
      ) : (
        "You can drag them in here, or use the Upload button."
      )}
    </Alert>
  );
};
